import { createSelector } from '@reduxjs/toolkit';
import { ApplicationSDKState } from 'sdk/interfaces/sdkInterface';

import { sliceName } from './userConfig';
import { UserState } from './userInterface';

export const sliceSelector = (state: ApplicationSDKState) => {
    return state[sliceName];
};

export const userErrorsSelector = createSelector(sliceSelector, (slice: UserState) => {
    return slice.error;
});
export const currentAppUserSelector = createSelector(sliceSelector, (slice: UserState) => {
    return slice.currentAppUser;
});
export const usersDisplayInfoSelector = createSelector(sliceSelector, (slice: UserState) => {
    return slice.usersDisplayInfo;
});